import { render, staticRenderFns } from "./InvoiceShow.vue?vue&type=template&id=2c20fa67"
import script from "./InvoiceShow.vue?vue&type=script&lang=js"
export * from "./InvoiceShow.vue?vue&type=script&lang=js"
import style0 from "./InvoiceShow.vue?vue&type=style&index=0&id=2c20fa67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports